<script>
import VClamp from 'vue-clamp';

import { lastComments } from '../api/comments';

export default {
  name: 'CpCommunityComments',
  components: {
    CpButton: require('../button').default,
    CpImage: require('../image').default,
    handleImageError: require('../mixins/utils').default,
    capitalizeFirstLetter: require('../mixins/utils.js').default,
    CpShowImageInCard: require('../components/ShowImageInCard').default,
    VClamp,
    MemberComponent: require('../components/MemberComponent').default,
    TruncateText: require('../components/TruncateText').default,
  },
  directives: {
    margin: require('../directives/margins').margin,
    marginTop: require('../directives/margins').marginTop,
    marginBottom: require('../directives/margins').marginBottom,
    marginLeft: require('../directives/margins').marginLeft,
  },
  mounted() {
    this.getCommunityComments();
  },
  data() {
    return {
      lastComments: [],
    };
  },
  methods: {
    getCommunityComments() {
      lastComments()
        .then(response => {
          this.lastComments = response.comments;
        })
        .catch(error => {
          console.warn(error);
        });
    },
    getCommentUrl(postPermalink, commentId) {
      if (postPermalink.includes('anchor=post')) {
        const separator = postPermalink.includes('?') ? '&' : '?';
        return `${postPermalink}${separator}comment=${commentId}`;
      }

      if (postPermalink.includes('#post')) {
        const [baseUrl] = postPermalink.split('#post');
        const separator = baseUrl.includes('?') ? '&' : '?';
        return `${baseUrl}${separator}comment=${commentId}#post`;
      }

      const urlWithoutFragment = postPermalink.split('#')[0];
      return `${urlWithoutFragment}#comment-${commentId}`;
    },
  },
};
</script>
<template>
  <div v-if="lastComments && lastComments.length" class="communityCommentsContainer">
    <h3 class="H3 black-color">Community Comments</h3>
    <a v-for="(item, index) in lastComments" :key="item.id" :href="getCommentUrl(item.post_permalink, item.id)" target="_blank" class="commentItemContainer">
      <p class="post-title-container" v-margin-top="0" v-margin-bottom="0">
        <TruncateText
          :content="item.post_title"
          :lineClamp="item.post_type === 'group_opinion' ? 1 : 3"
          :withMoreButton="false"
          textClass="caption1 black-color"
        />
      </p>
      <div class="comment">
        <MemberComponent :image="item.profile_image" :fullname="item.name" :description="item.comment" :maxLines="1" :permalink="null" />
      </div>
      <div v-if="index < lastComments.length - 1" class="separator"></div>
    </a>
  </div>
</template>

<style scoped>
.communityCommentsContainer {
  width: 100%;
  max-width: 100%;
}
.commentItemContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px;
  margin: 4px 0;
  cursor: pointer;
  transition: all 0.2s ease;
  border-radius: 8px;
}

.commentItemContainer:hover {
  background-color: var(--neutral1);
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.post-title-container {
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.post-title-container :deep(.text-container) {
  width: 100%;
  max-width: 100%;
}
.comment {
  width: 100%;
  max-width: 100%;
}
.separator {
  width: 50%;
  margin: 4px 0;
  height: 1px;
  background-color: var(--neutral3);
}
</style>
